import React,{Component} from 'react'
import PropTypes from 'prop-types'
import styles from './index.scss'

class Index extends Component{
    static propTypes = {
        text: PropTypes.string
    }
    static defaultProps = {
        text: '暂无数据~'
    }
    render(){
        return(
            <div className={styles['nodata-wrapper']}>
                    <img src="/static/images/no.png"/>
                        <p>{this.props.text}</p>
            </div>
        )
    }

}

export default Index
